export enum FilterType {
  text = 'text',
  date = 'date',
  datetime = 'datetime',
  number = 'number',
  currency = 'currency',
  boolean = 'boolean',
  enum = 'enum',
  autocomplete = 'autocomplete',
}
